<script>
	import {Router, Route, Link} from "svelte-routing";
	import Modal from 'svelte-simple-modal';
	import MenuAdministration from "./MenuAdministration.svelte";
	import Header from "./Header.svelte";
	import LandingPage from "./LandingPage.svelte";
	import MenuItemAdministration from "./MenuItemAdministration.svelte";
	import ContentItemDetails from "./ContentItemDetails.svelte";
	import SettingsComponent from "./Settings/SettingsComponent.svelte";
	import RegisterUserComponent from "./UserManagement/RegisterUser/RegisterUserComponent.svelte";
	import LoginComponent from "./UserManagement/Login/LoginComponent.svelte";
	import NewFormComponent from "./FormItem/NewFormComponent.svelte";
	import RegisterUserContentComponent from "./UserManagement/RegisterUser/RegisterUserContentComponent.svelte";
	import NewMapComponent from "./MapItem/NewMapComponent.svelte";

	export let url = ""; //This property is necessary declare to avoid ignore the Router
	export let model_root;
	export let application_root;

	let logged_in = fetch(model_root + 'admin/user_management/is_logged_in.php', {
		method: "GET"
	})
			.then(response => response.text());
</script>

<Router url="{url}">

	<Modal>
		<main class="rounded">
			<div class="container">
				<div class="row">

					{#await logged_in}
						<p class="text-center mt-4 mb-4"><i class="fas fa-circle-notch fa-spin"></i> Bitte warten Sie einen Moment...</p>
					{:then logged_in_value}
						{#if logged_in_value === "1"}

							<div class="col-lg-3 py-2 px-4 shadow-sm rounded nav-panel">
								<Header {model_root} />
							</div>
							<div class="col-lg-9 ps-lg-5">
<!--								<Route path="/"><MenuItemAdministration {model_root} {application_root} id="36" /></Route>-->
								<!--<Route path=""><NewFormComponent {model_root} /></Route>-->
								<!--<Route path="/"><LoginComponent {model_root} /></Route>-->
								<!--<Route path="/"><SettingsComponent {model_root} active="user_management" /></Route>-->
								<Route path="/"><LandingPage /></Route>
								<Route path="menu-administration">
									<MenuAdministration {model_root} footer="0" />
								</Route>
								<Route path="footer-administration">
									<MenuAdministration {model_root} footer="1" />
								</Route>
								<Route path="settings">
									<SettingsComponent {model_root} active="general_settings" />
								</Route>
								<Route path="settings/users">
									<SettingsComponent {model_root} active="user_management" />
								</Route>
								<Route path="settings/profile">
									<SettingsComponent {model_root} active="profile" />
								</Route>
								<Route path="menu-item/:id" let:params>
									<MenuItemAdministration {model_root} {application_root} id="{params.id}" />
								</Route>
								<Route path="create-content/:id" let:params>
									<ContentItemDetails {model_root} mid="{params.id}" ctype="TEXT_CONTENT" />
								</Route>
								<Route path="create-form-content/:id" let:params>
									<ContentItemDetails {model_root} mid="{params.id}" ctype="FORM_CONTENT" />
								</Route>
								<Route path="create-map-content/:id" let:params>
									<ContentItemDetails {model_root} mid="{params.id}" ctype="MAP_CONTENT" />
								</Route>
								<Route path="edit-map-data/:mid/:cid/:cname" let:params>
									<NewMapComponent {model_root} mid="{params.mid}" cid="{params.cid}" cname="{params.cname}" />
								</Route>
								<Route path="edit-content/:mid/:cid" let:params>
									<ContentItemDetails {model_root} edit={true} mid="{params.mid}" cid="{params.cid}" />
								</Route>
							</div>

						{:else}
							<LoginComponent {model_root} />
<!--							<RegisterUserComponent {model_root} hash="1f9a317c08d0377767ecff3b0d18a8d71ac02c5a"/>-->

							<Route path="register/:hash" let:params>
								<RegisterUserComponent {model_root} hash="{params.hash}"/>
							</Route>
						{/if}
					{:catch error}
						<div class="alert alert-danger" role="alert">
							Ein Fehler ist aufgetreten!
						</div>
					{/await}

				</div>
			</div>
		</main>
	</Modal>

</Router>

<style>

	:global(body) {
		padding: 0px;
	}

	:global(main) {
		padding-top: 20px;
		padding-bottom: 30px;
	}

	.nav-panel {
		background-color: #2c3e50;
	}

</style>
